/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-param-reassign */
import { DownOutlined } from '@ant-design/icons';
import {
  Card,
  Empty,
  Table
} from 'antd';
import PropTypes from 'prop-types';
import React, {
  useEffect, useMemo, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import allActions from '../../../../../actions';
import Loading from '../../../../../components/loading/Loading';
import { generateTabHeaders, renderCellContent } from '../../../components/helpers';
import { hiddenColumns } from '../../TabOptions';

import './TableTab.css';

function TableTab({
  action,
  loadingKey,
  tabOptions,
  updateFilterData,
  containerID,
  hideSensitiveValues,
  data,
  tableTitle,
  clientHeight,
  headers,
  footer,
  activeTabKey,
  openQtyResvalue
}) {
  const { plant, material } = useParams();
  const dispatch = useDispatch();
  const [headerData, setHeaderData] = useState();
  const loading = useSelector((state) => state.materialDetailsState.loading);
  const columnMapper = useSelector((state) => state.commonState.columnMapper);
  const openQtyRes = useSelector((state) => state.materialDetailsState);
  const [scrollX, setScrollX] = useState({});
  const [allMovementsTableLengthCalc, setAllMovementsTableLengthCalc] = useState(1);

  useEffect(() => {
    if (plant && material) {
      dispatch(allActions.MaterialDetailsActions.setLoading(loadingKey));
      dispatch(action(plant, material));
    }
  }, [plant, material, activeTabKey]);

  // const scrollIds = ['tabRealConsTable'];

  useEffect(() => {
    // setScrollX(scrollIds.includes(containerID)
    //   ? { x: true, y: clientHeight } : { y: clientHeight });
    const scroll = containerID === 'tabRealConsTable' ? { x: 1100, y: clientHeight } : { y: clientHeight };
    setScrollX(scroll);
  }, [containerID, clientHeight]);

  useEffect(() => {
    let allMovements = null;
    if (containerID === 'tabAllMovements') {
      allMovements = true;
    }
    if (data?.length >= 1 && columnMapper?.length >= 1) {
      const keys = Object.keys(data[0]);
      let tempHeaders;
      if (headers) tempHeaders = headers;
      else tempHeaders = generateTabHeaders(keys, columnMapper, tabOptions, data, allMovements);
      setHeaderData(tempHeaders);
      if (updateFilterData) {
        updateFilterData(data);
      }
    } else {
      if (updateFilterData) {
        updateFilterData();
      }
      setHeaderData();
    }
  }, [data, columnMapper, containerID, headers]);

  useEffect(() => {
    document.querySelectorAll('.ant-table-cell .lightred, .ant-table-cell .lightgreen, .ant-table-cell .excluded, .ant-table-cell .lightorange')
      .forEach((ele) => {
        if (ele.className === 'lightred') {
          ele.parentElement.style.padding = '0';
        } else if (ele.className === 'lightgreen') {
          ele.parentElement.style.padding = '0';
        } else if (ele.className === 'excluded') {
          ele.parentElement.style.padding = '0';
        }
        // eslint-disable-next-line default-case
        switch (ele.className) {
          case 'lightred':
            ele.parentElement.style.setProperty('background-color', 'rgb(255, 204, 203)', 'important');
            break;
          case 'lightgreen':
            ele.parentElement.style.setProperty('background-color', 'lightgreen', 'important');
            break;
          case 'lightorange':
            ele.parentElement.style.setProperty('background-color', 'rgb(255, 185, 147)', 'important');
            break;
          // case 'inlinecell':
          //   ele.parentElement.style.setProperty('display', 'inline', 'important');
        }
      });
  }, [headerData]);

  const removeSensitiveValues = (source, sensitiveValueArray) => {
    const sensitiveValueObject = {};
    sensitiveValueArray.forEach((value) => {
      sensitiveValueObject[value] = '';
    });
    return source.map((x) => ({ ...x, ...sensitiveValueObject }));
  };

  const getRowClassName = (record, index) => {
    const className = (tabOptions?.rowClassName && tabOptions.rowClassName(record)) || null;
    if (className) return className;
    return (index % 2 === 0 ? 'table-row-light' : 'table-row-dark');
  };

  const columns = useMemo(
    () => {
      if (!headerData || headerData.length === 0) return [];
      return headerData?.filter((h) => (!hiddenColumns?.includes(h.dataIndex)));
    },
    [headerData],
  );

  const getCorrectDate = (date) => {
    const dateAndTime = date.split('T');
    const dayMonthYear = dateAndTime[0].split('-');
    const hourMinute = dateAndTime[1].split(':');
    const string = `${dayMonthYear[2]}.${dayMonthYear[1]}.${dayMonthYear[0]}, ${hourMinute[0]}:${hourMinute[1]} CEST`;
    return string;
  };

  const dataSource = useMemo(
    () => {
      if (!data || !headerData || data.length === 0 || headerData.length === 0) return [];

      const listToUse = (containerID === 'tabAllMovements' && data.length > 100)
        ? data.slice(-100 * allMovementsTableLengthCalc)
        : data;

      if (hideSensitiveValues && tabOptions?.sensitiveValues) {
        return removeSensitiveValues(listToUse, tabOptions?.sensitiveValues);
      }
      if (loadingKey === 'CHANGELOGS') {
        const newData = listToUse.filter((i) => i.CHANGE_TYPE !== 'No MRP changes');
        const correctDate = newData.map(
          (changeObject) => ({
            ...changeObject,
            CHANGED_DATE: getCorrectDate(changeObject.CHANGED_DATE)
          })
        );
        return correctDate;
      }
      return listToUse;
    }, [data, headerData, allMovementsTableLengthCalc],
  );

  return (
    loading && loading[loadingKey]
      ? <Loading />
      : (
        <>
          {
            tableTitle && (
              <h3 style={{ color: 'var(--neutral--400)', marginLeft: '0.5rem' }}>
                {tableTitle}
              </h3>
            )
          }
          <div
            style={{ height: '100%' }}
            id={containerID === 'tabAllMovements' ? 'tableContainerForButton' : ''}
          >
            {
              (!data || !headerData)
                ? <Empty description="No data" />
                : (

                  <Card
                    className="tabCard"
                    style={{
                      textAlign: 'center', paddingLeft: '0', paddingRight: '0', height: '95%', boxSizing: 'border-box', position: 'relative',
                    }}
                  >
                    <Table
                      className="tabTable"
                      rowClassName={getRowClassName}
                      columns={columns.map((col) => ({
                        ...col,
                        render: col.dataIndex === 'PLANT_FACILITY_SAP_ID'
                          ? (text, record) => renderCellContent(text, record, material)
                          : col.render,
                      }))}
                      dataSource={dataSource}
                      pagination={false}
                      size="small"
                      onChange={(_p, _f, _s, extra) => updateFilterData(extra.currentDataSource)}
                      scroll={scrollX}
                      style={{ maxHeight: '100%' }}
                      footer={() => (
                        activeTabKey === 'RES' ? (
                          <div className="openQtyResfield">
                            Sum:
                            {' '}
                            {
                              openQtyResvalue
                            }
                          </div>
                        ) : footer
                      )}
                    />
                    {(containerID === 'tabAllMovements' && data?.length > 100) && (
                      <div
                        className="loadMoreButton"
                        onClick={() => setAllMovementsTableLengthCalc(
                          (prev) => prev + 1,
                        )}
                      >
                        Showing
                        {' '}
                        <span style={{ fontWeight: '600' }}>{100 * allMovementsTableLengthCalc}</span>
                        {' '}
                        of
                        <span style={{ fontWeight: '600' }}>{data?.length}</span>
                        {' '}
                        rows. Load more
                        <DownOutlined />
                      </div>
                    )}
                  </Card>

                )
            }
          </div>
        </>
      )
  );
}

export default TableTab;

TableTab.defaultProps = {
  tabOptions: {},
  updateFilterData: () => { },
  containerID: '',
  hideSensitiveValues: true,
  headers: null,
  data: null,
  tableTitle: '',
  clientHeight: 900,
  footer: null,
};

TableTab.propTypes = {
  action: PropTypes.func.isRequired,
  loadingKey: PropTypes.string.isRequired,
  tabOptions: PropTypes.objectOf(PropTypes.any),
  updateFilterData: PropTypes.func,
  containerID: PropTypes.string,
  hideSensitiveValues: PropTypes.bool,
  headers: PropTypes.arrayOf(PropTypes.any),
  data: PropTypes.arrayOf(PropTypes.any),
  tableTitle: PropTypes.string,
  activeTabKey: PropTypes.string.isRequired,
  clientHeight: PropTypes.number,
  footer: PropTypes.element,
  openQtyResvalue: PropTypes.number.isRequired,
};
